import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Northlight',
    description: 'Northlight is the photography studio of Rowan Vale, working in portraiture, landscape and documentary work from Edinburgh and further north.',
    placeholder: 'Your new site will appear right here. Just ask Modulify to generate anything you can describe.',
    url: getOrigin()
}

export const contact = {
    email: 'studio@northlight.photo',
    phone: '+44 131 555 0148',
    city: 'Edinburgh, Scotland',
    address: ['Northlight Studio', 'Unit 4, Bonnington Works', 'Edinburgh EH6 5NP'],
    hours: 'Studio open Tuesday to Friday, 9am until 6pm',
    response: 'Enquiries answered within two working days'
}

export const social = [
    { label: 'Instagram', href: 'https://instagram.com' },
    { label: 'X.com', href: 'https://x.com' }
]

export const navigation = [
    { label: 'Home', href: '/' },
    { label: 'Portfolio', href: '/portfolio' },
    { label: 'Blog', href: '/blog' },
    { label: 'About me', href: '/about' },
    { label: 'Contact', href: '/contact' }
]

/** The status line in the header bar, beside its pulsing dot. */
export const availability = 'Booking into 2027'

/** Photographer behind the studio, shown in the header rail and bylines. */
export const author = {
    name: 'Rowan Vale',
    role: 'Photographer',
    based: '(Based in Edinburgh)',
    portrait: '/images/founder.jpg'
}
